import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      newsAndSocial: {
        RESET: 'Reset',
        VIEW_BY: 'View by',
        BOOKMARK: 'Bookmark',
        NEWS_TYPES: 'News types',
        TIME_PERIOD: 'Time period',
        SENTIMENTS: 'Sentiments',
        EVENTS: 'Event',
        SOURCE: 'Source',
        HEADLINE: 'Headline',
        PUBLICATION_DATE: 'Publication Date',
        REMOVE_BOOKMARK: 'Remove bookmark',
        ADD_BOOKMARK: 'Add bookmark',
        LINK_ARTICLE: 'Article link',
        NO_DATA: 'No results match your criteria',
        PLACE_HOLDER_SEARCH: 'Search by headline (Enter at least 2 characters)',
        ALL_TIME: 'All time (past 5 years)',
        PAST30DAYS: 'Past 30 days',
        PAST90DAYS: 'Past 90 days',
        PAST6MONTHS: 'Past 6 months',
        PAST1YEAR: 'Past 1 years',
        CUSTOM_DATE: 'Custom range',
        DISCLAIMER:
          'FiinGate summarized each article at its collected date. Readers should do their own fact-checking and visit the original source for any further updates.',
        LANGUAGE: 'Language',
        VIETNAMESE: 'Vietnamese',
        ENGLISH: 'English',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      newsAndSocial: {
        RESET: 'Đặt lại',
        VIEW_BY: 'Xem theo',
        BOOKMARK: 'Dấu trang',
        NEWS_TYPES: 'Loại tin tức',
        TIME_PERIOD: 'Khoảng thời gian',
        SENTIMENTS: 'Trạng Thái',
        EVENTS: 'Sự Kiện',
        SOURCE: 'Nguồn',
        HEADLINE: 'Tiêu Đề',
        PUBLICATION_DATE: 'Ngày Phát Hành',
        REMOVE_BOOKMARK: ' Xóa dấu trang',
        ADD_BOOKMARK: 'Thêm dấu trang',
        LINK_ARTICLE: 'Liên kết bài viết',
        NO_DATA: 'Không tìm thấy kết quả phù hợp',
        PLACE_HOLDER_SEARCH: 'Tìm kiếm theo tiêu đề (Nhập ít nhất 2 ký tự)',
        ALL_TIME: 'Tất cả (5 năm qua)',
        PAST30DAYS: '30 ngày qua',
        PAST90DAYS: '90 ngày qua',
        PAST6MONTHS: '6 tháng qua',
        PAST1YEAR: '1 năm qua',
        CUSTOM_DATE: 'Tùy chỉnh',
        DISCLAIMER:
          'FiinGate thực hiện tóm tắt từng bài báo vào ngày thu thập thông tin. Người đọc nên tự xác thực và truy cập nguồn tin chính thức để kiểm tra tính cập nhật của thông tin',
        LANGUAGE: 'Ngôn ngữ',
        VIETNAMESE: 'Tiếng Việt',
        ENGLISH: 'Tiếng Anh',
      },
    },
  }),
)
